import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { PharmacyResponse, UpdatePharmacyParams } from 'types/api/pharmacies/pharmacy';
import { type ApiError, faksApiInstance as api } from './api';

export const useUpdatePharmacyMutation = (
  options?: UseMutationOptions<PharmacyResponse, AxiosError<ApiError>, UpdatePharmacyParams>
): UseMutationResult<PharmacyResponse, AxiosError<ApiError>, UpdatePharmacyParams> =>
  useMutation({
    mutationFn: (params) => api.patch<PharmacyResponse>(`pharmacies/${params.pharmacy.id}`, params),
    ...options,
  });
